module.exports = __webpack_public_path__ + "img/TerrorBlade.5747a9ee.png";